import {useTranslation} from "../../../../__snowpack__/link/packages/i18n/dist/i18n.esm.js";
import MaterialGrid from "../../../../__snowpack__/pkg/@mui/material/Grid.js";
import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React, {useCallback} from "react";
import Button from "../../atoms/button/button.component.js";
import MergeQueueCard from "../../molecules/merge-queue-card/merge-queue-card.component.js";
import MergeUnitEmptyState from "../../molecules/merge-unit-empty-state/merge-unit-empty-state.component.js";
import {MergeUnitsQueueActions, MergeUnitsQueueContainer, MergeUnitsQueueHeader} from "./merge-units-queue.styles.js";
function MergeUnitsQueue({
  mergeQueue,
  onMerge,
  onRemoveFromQueue,
  onClearQueue
}) {
  const {
    t
  } = useTranslation();
  const renderMergeUnitCard = useCallback((suggestion, index) => {
    return /* @__PURE__ */ React.createElement(MergeQueueCard, {
      key: index,
      mergeSuggestion: suggestion,
      onMerge: () => onMerge([suggestion], index),
      onRemoveFromQueue: () => onRemoveFromQueue(index)
    });
  }, [onMerge, onRemoveFromQueue]);
  const renderUnitQueueContent = useCallback(() => {
    if (!mergeQueue.length) {
      return /* @__PURE__ */ React.createElement(MergeUnitEmptyState, {
        icon: "help_outline",
        content: t("units.mergeQueueEmptyState"),
        direction: "row"
      });
    }
    return /* @__PURE__ */ React.createElement(MaterialGrid, {
      container: true,
      spacing: 2
    }, mergeQueue.map((suggestion, index) => renderMergeUnitCard(suggestion, index)));
  }, [mergeQueue, renderMergeUnitCard, t]);
  return /* @__PURE__ */ React.createElement(MergeUnitsQueueContainer, null, /* @__PURE__ */ React.createElement(MergeUnitsQueueHeader, null, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: "h5"
  }, t("units.mergeQueue")), /* @__PURE__ */ React.createElement(MergeUnitsQueueActions, null, /* @__PURE__ */ React.createElement(Button, {
    onClick: () => onClearQueue(),
    variant: "text",
    disabled: !mergeQueue.length
  }, t("units.mergeQueueClear")), /* @__PURE__ */ React.createElement(Button, {
    onClick: () => onMerge(mergeQueue),
    variant: "text",
    disabled: !mergeQueue.length
  }, t("units.mergeQueueMergeAll")))), renderUnitQueueContent());
}
export default /* @__PURE__ */ React.memo(MergeUnitsQueue);
